import React, { useEffect } from 'react';
import c3 from 'c3';
import './c3.min.css';

export default function PaymentTrendsGraph(props) {

    useEffect(() => {
        if (props.data?.length > 0) {
            renderChart(props.data);
        }
    }, [props.data]);     // eslint-disable-line react-hooks/exhaustive-deps

    function buildLegendColors() {
        let legendColors = [];
        if (props.legendData) {
            props.legendData.forEach(item => {
                switch (item[0]) {
                    case 'Check Payments':
                        return legendColors.push('#007AA3');
                    case 'Deposit to Debit Card Payments':
                        return legendColors.push('#4FA800');
                    case 'Virtual Credit Card Payments':
                        return legendColors.push('#E30000');
                    case 'Direct Deposit Payments':
                        return legendColors.push('#FFB300');
                    case 'eCheck Payments':
                        return legendColors.push('#808080');
                    case 'Lienholder Payments':
                        return legendColors.push('#006747');
                    default:
                        // Unknown Type
                        return legendColors.push('#000');
                }
            });
        }
        return legendColors;
    }

    function renderChart(data) {
        c3.generate({
            type: 'line',
            bindto: '#ptGraph',
            padding: {
                right: 60
            },
            data: {
                x: 'X',
                columns: data,
                type: 'area-spline'
            },
            color: {
                pattern: buildLegendColors()
            },
            legend: {
                show: false,
                position: 'inset',
                inset: {
                    anchor: 'top-right'
                }
            },
            axis: {
                x: {
                    type: 'category',
                    tick: {
                        centered: true,
                        culling: true,
                        width: 40
                    },
                    padding: {
                        left: -0.45,
                        right: -0.45
                    }

                },
                y: {
                    tick: {
                        format: d => parseInt(d) === d ? d : null
                    },
                    default: []
                }
            },
            point: {
                show: d => d.value > 0
            }
        });
    };

    return (
        <div data-testid="payment-trends-graph">
            <div id="ptGraph">
                <div className="efup-payment-trends-no-payments">There are no payments processed during the selected date range.</div>
            </div>
        </div>
    );
}